import { memo } from 'react';

import { useGetCommonStore } from '@/store';

import {
  ScLeftArrowOutside,
  ScOutsideArrows,
  ScOutsideArrowsContainer,
  ScRightArrowOutside,
} from './styled';

interface IOutsideArrows {
  rightComponent?: React.ReactNode;
  leftComponent?: React.ReactNode;
  visibleForMobile?: boolean;
  isBeginning: boolean;
  isEnd: boolean;
  dark?: boolean;
  handlePrevClick: () => void;
  handleNextClick: () => void;
}

export const OutsideArrows = memo(
  ({
    rightComponent,
    leftComponent,
    visibleForMobile,
    handlePrevClick,
    handleNextClick,
    isBeginning,
    isEnd,
    dark,
  }: IOutsideArrows) => {
    const useCommonStore = useGetCommonStore();

    const isMobileDevice = useCommonStore.use.isMobileDevice();

    return (
      <ScOutsideArrowsContainer visibleArrowsForMobile={visibleForMobile}>
        {leftComponent}
        <div>
          {rightComponent}
          {(!isMobileDevice || visibleForMobile) && (
            <ScOutsideArrows dark={dark}>
              <ScLeftArrowOutside
                aria-label="arrow left"
                data-testid="slider-prev-arrow"
                isActive={!isBeginning}
                onClick={handlePrevClick}
              />
              <div className="divider" />
              <ScRightArrowOutside
                aria-label="arrow right"
                data-testid="slider-next-arrow"
                isActive={!isEnd}
                onClick={handleNextClick}
              />
            </ScOutsideArrows>
          )}
        </div>
      </ScOutsideArrowsContainer>
    );
  }
);
